import React, { useEffect, useRef, useState } from "react";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { AproveJobtime } from "../../../../../../../../redux/job/action";
import PostNotFound from "../../../../../../../CustomComponents/AllLoader/PostNotFound";
import { getDateFormate } from "../../../../../../../Common/AllDateTimeReleventFormate";

export default function JobArchivedSheetLists({
  proposalmilestones,
  posts,
  setTimeData,
  setExtraData,
  setExtraModal,
}) {
  const [show, setShow] = useState(0);
  const [loading, setLoading] = useState(false);
  const [buttonactive, setButtonActive] = useState(0);
  const dispatch = useDispatch();

  const aprroveJobTime = (id) => {
    const data = {
      type: "1",
      job_time_archived_id: id,
      status: "1",
      posts_id: posts?.id,
    };
    dispatch(AproveJobtime(data, setLoading, (res) => {
      setExtraData(res);
      setExtraModal(true);
    }));
  };

  const handleClick = (id) => {
    setButtonActive((prev) => (prev == id ? 0 : id));
  };
  const settimedata = (item) => {
    setTimeData(item);
  };

  // Inside your component function:
  const dropdownRef = useRef(null);

  // Add this useEffect hook
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        handleClick(null); // or setButtonactive(null) depending on your state setter name
      }
    };

    // Only add listener if dropdown is active
    if (buttonactive) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [buttonactive]);

  return (
    <>
      <div>
        <div className="week-section">
          <div className="tabcont-heading">
            <h5>{posts?.hiring_type == 4 ? "Last month" : "Last week"}</h5>
            <h5>
              {posts?.hiring_type == 4 ? "Monthly Total" : "Weekly Total"} : {proposalmilestones?.job_time_archived_duration}
            </h5>
          </div>
        </div>
        {Array.isArray(proposalmilestones?.job_time_archived) &&
          proposalmilestones?.job_time_archived?.length > 0 ? (
          proposalmilestones?.job_time_archived?.map((item, index) => (
            <div className="week-section" key={item?.id}>
              <div className="week-collpase">
                <h6 className="" onClick={() => {
                  setShow(prev => {
                    if (prev == item.id) return 0;       // clicking same ID → reset
                    return item.id;                       // clicking new → set new ID
                  });
                }}>
                  {getDateFormate(item?.date)}
                  <span>Total : {item?.duration}</span>
                </h6>
                <div className="col-md-12 bg-white pt-2 mock-head" style={{ borderBottom: "2px solid gray" }}>
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <h6>Description</h6>
                    </div>
                    <div className="col-md-3 mockup-center d-flex align-items-center justify-content-between">
                      <h6>Start Time</h6>
                      <h6>End Time</h6>
                    </div>
                    <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                      <h6>Total Worked Hours</h6>
                    </div>

                    <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                      <h6>Status</h6> 
                      <h6>Action</h6>
                    </div>
                  </div>
                </div>
                {Array.isArray(item?.job_time) &&
                  item?.job_time?.length > 0 &&
                  item?.job_time?.map((item1, index1) => (
                    <div
                      style={{ borderBottom: "2px solid gray" }}
                      className={`mockup-row ${show == item1?.id ? "show" : ""}`}
                      key={index1}
                    >
                      <div className="mockup">
                        <div className="col-md-12">
                          <div className="row align-items-center">
                            <div className="col-md-3">
                              <p>{item1?.message}</p>
                            </div>
                            <div className="col-md-3 mockup-center d-flex align-items-center justify-content-between">
                              <p>{item1?.start_time}</p>
                              <p>{item1?.end_time}</p>
                            </div>
                            {posts?.is_mine == 1 ? (
                              <>
                                <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                                  <h5>{item1?.duration}</h5>
                                </div>

                                {item1?.status == 0 ? (
                                  <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                                    <p className="pending">Pending</p>
                                    <div className="d-flex align-items-center" style={{ columnGap: "10px" }}>
                                      <a>
                                      <img
                                        src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                                        alt=""
                                      />
                                    </a>
                                    <a>
                                      <img
                                        onClick={() =>
                                          aprroveJobTime(item1?.id)
                                        }
                                        src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                                        alt=""
                                      />
                                    </a>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                                    {item1?.status == 2 ? (
                                      <p
                                        style={{
                                          background: "orange",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Rejected
                                      </p>
                                    ) : item1?.status == 3 ? (
                                      <p
                                        style={{
                                          background: "red",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Deleted
                                      </p>
                                    ) : (
                                      <p
                                        style={{
                                          background: "green",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Approved
                                      </p>
                                    )}
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                {/* <a className="calendar-icon">
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                                    alt=""
                                  />
                                </a> */}
                                <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between">
                                  <h5 style={{ minWidth: 'max-content' }}>{item1?.duration}</h5>
                                </div>
                                {item1?.status == 0 ? (
                                  <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between" style={{columnGap:'10px'}}>
                                    <p className="pending">Pending</p>
                                    <div
                                      ref={dropdownRef}
                                      className={`dropdown ${buttonactive === item1?.id ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(item1?.id);
                                      }}
                                    >
                                      <button className="btn">
                                        <img
                                          src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                                          alt=""
                                        />
                                      </button>
                                      <div className="dropdown-content">
                                        <a onClick={(e) => {
                                          e.stopPropagation();
                                          settimedata(item1);
                                          handleClick(null); // Close after action
                                        }}>
                                          Duplicate
                                        </a>
                                        {/* <a className="delete">Delete Entry</a> */}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="col-md-3 mockup-right d-flex align-items-center justify-content-between" style={{columnGap:'10px'}}>
                                    {item1?.status == 2 ? (
                                      <p
                                        style={{
                                          background: "orange",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Rejected
                                      </p>
                                    ) : item1?.status == 3 ? (
                                      <p
                                        style={{
                                          background: "red",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Deleted
                                      </p>
                                    ) : (
                                      <p
                                        style={{
                                          background: "green",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Approved
                                      </p>
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <PostNotFound title={"No archived timesheets found"} />
        )}
      </div>
    </>
  );
}
